import React, { FC } from 'react';

import '../../store/card/card.interface';
import {
  IReviewCommentResponse,
  IReviewsComments,
} from '../../store/review/review.interface';

import ReviewItem from './ReviewItem/ReviewItem';

const ReviewList: FC<{ review: IReviewsComments[] | undefined }> = ({
  review,
}) => {
  if (!review) return null;

  return (
    <div>
      {review &&
        review.map((review, index) => {
          return <ReviewItem key={`${review.id}_${index}`} review={review} />;
        })}
    </div>
  );
};

export default ReviewList;
